import { useContext } from 'react';
import SettingsContext from '../context/SettingsContext';
import moment from 'moment-timezone';

function normalizeTimezone(tzString) {
	if (!tzString) return null;

	// If it's just a GMT offset (no region/city)
	const offsetMatch = tzString.match(/^GMT\s*([+-]\d{2}:\d{2})$/);
	if (offsetMatch) {
		return `UTC${offsetMatch[1]}`; // e.g. "UTC-04:00"
	}

	// Strip the "GMT ±HH:mm" prefix
	let cleaned = tzString.replace(/^GMT\s*[+-]\d{2}:\d{2}\s*/, '').trim();

	// Convert spaces to underscores (for cases like "America/New York")
	cleaned = cleaned.replace(/\s+/g, '_');

	// Validate against IANA DB
	if (moment.tz.zone(cleaned)) {
		return cleaned;
	}

	return null;
}

const useSettings = () => {
	const localUser = localStorage.getItem('user');

	const {
		settings,
		loading: isLoadingSettings,
		update: updateSettings,
	} = useContext(SettingsContext);

	return {
		loading: isLoadingSettings,
		user: settings?.user || {},
		organization: settings?.company || {},
		set: (type, key, value, opts) => {
			updateSettings(
				{
					type,
					key,
					value,
				},
				opts,
			);
		},
		get: (name) => {
			if (typeof settings?.user[name] !== 'undefined') {
				return settings?.user[name];
			} else if (typeof settings?.company[name] !== 'undefined') {
				return settings?.company[name];
			}
			return null;
		},
		timezone: normalizeTimezone(
			JSON.parse(localUser)?.timezone || 'GMT -04:00 America/New York',
		),
	};
};

export default useSettings;
